export const SHORT_DATE_ES = 'dd-MM-yyyy';
export const SHORT_DATE_EN = 'yyyy-MM-dd';
export const YEAR_MONTH_GSI = 'yyyyMM';
